module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(!_vm.tableList.id) ? _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('p', [_vm._v("此店家無桌位！")])]) : _vm._e(), _vm._v(" "), (_vm.tableList.id) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("桌位設定ID：" + _vm._s(_vm.tableList.id))]), _vm._v(" "), _c('p', [_vm._v("桌位建立時間：" + _vm._s(_vm.tableList.create_time))])]) : _vm._e(), _vm._v(" "), (_vm.tableList.id) ? _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.tableList.item_list), function(floor) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped dataTable",
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid"
      }
    }, [_c('thead', [_c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('th', [_vm._v(_vm._s(floor.name) + " (" + _vm._s(floor.id) + ")\n            "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("pos table_id：" + _vm._s(floor.vendor_custom_id))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('p', [_vm._v("排序：" + _vm._s(floor.sort))]), _vm._v(" "), _c('p', [_vm._v("前端顯示：\n                  "), (floor.is_visible) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!floor.is_visible) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不顯示")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('p', [_vm._v("暫停使用：\n                  "), (!floor.is_suspend) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (floor.is_suspend) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("暫停")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("使用狀況：\n                  "), (!floor.is_available) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("無人")]) : _vm._e(), _vm._v(" "), (floor.is_available) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("使用中")]) : _vm._e()])])])]), _vm._v(" "), _c('tr', {
      attrs: {
        "role": "row"
      }
    }, _vm._l((floor.child_list), function(table) {
      return _c('div', {
        staticClass: "inline-block table-block"
      }, [_c('h4', {
        staticClass: "text-center text-600 table-header"
      }, [_vm._v(_vm._s(table.name) + " (" + _vm._s(table.id) + ")")]), _vm._v(" "), _c('div', {
        staticClass: "word-block"
      }, [_c('p', [_vm._v("\n                  pos table_id：" + _vm._s(table.vendor_custom_id) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  排序：" + _vm._s(table.sort) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  前端顯示：\n                  "), (table.is_visible) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!table.is_visible) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("不顯示")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("暫停使用：\n                  "), (!table.is_suspend) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (table.is_suspend) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("暫停")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("使用狀況：\n                  "), (!table.is_available) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("無人")]) : _vm._e(), _vm._v(" "), (table.is_available) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v("使用中")]) : _vm._e()])])])
    }), 0)])]), _vm._v(" "), _c('br')])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1493d4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/TableSettingTemp.vue
// module id = 2527
// module chunks = 1